import HeaderOne from './header/HeaderOne';
import FooterOne from './footer/FooterOne';

const Layout = ( { children } ) => {
    return (
        <>
            <main className="main-wrapper">
                <HeaderOne id='top-header'/>
                { children }
                <FooterOne />
            </main>
        </>
    )
}
export default Layout;